module.exports = __webpack_public_path__ + "static/media/1021456.91f54a50.jpg";